document.addEventListener('DOMContentLoaded', function () {

    const elements = document.querySelectorAll('.coll_top_content');
    const wordLimit = 50;

    elements.forEach(function(element) {

        const originalHTML = element.innerHTML;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = originalHTML;

        let totalWords = 0;
        let exceeded = false;

        const shortContainer = document.createElement('div');
        const fullContainer = document.createElement('div');

        function processNode(node, shortParent, fullParent) {

            if (node.nodeType === Node.TEXT_NODE) {

                const words = node.textContent.split(/\s+/);

                if (!exceeded) {

                    totalWords += words.length;

                    if (totalWords <= wordLimit) {

                        shortParent.appendChild(node.cloneNode(true));
                        fullParent.appendChild(node.cloneNode(true));

                    } else {

                        exceeded = true;

                        const allowed =
                            words.slice(0, words.length - (totalWords - wordLimit)).join(' ');

                        shortParent.appendChild(
                            document.createTextNode(allowed + '...')
                        );

                        fullParent.appendChild(node.cloneNode(true));
                    }

                } else {
                    fullParent.appendChild(node.cloneNode(true));
                }

            } else if (node.nodeType === Node.ELEMENT_NODE) {

                const shortClone = node.cloneNode(false);
                const fullClone = node.cloneNode(false);

                shortParent.appendChild(shortClone);
                fullParent.appendChild(fullClone);

                node.childNodes.forEach(function(child) {
                    processNode(child, shortClone, fullClone);
                });

            }

        }

        tempDiv.childNodes.forEach(function(node) {
            processNode(node, shortContainer, fullContainer);
        });

        if (!exceeded) {
            return;
        }

        element.innerHTML = `
            <div class="read-more-short"></div>
            <div class="read-more-full" style="display:none;"></div>
            <button class="read-more-btn" type="button">
                Lees meer...
            </button>
        `;

        element.querySelector('.read-more-short').appendChild(shortContainer);
        element.querySelector('.read-more-full').appendChild(fullContainer);

        const button = element.querySelector('.read-more-btn');
        const shortBlock = element.querySelector('.read-more-short');
        const fullBlock = element.querySelector('.read-more-full');

        button.addEventListener('click', function() {

            const isOpen = fullBlock.style.display === 'block';

            if (isOpen) {

                fullBlock.style.display = 'none';
                shortBlock.style.display = 'block';
                button.textContent = 'Lees meer...';

            } else {

                fullBlock.style.display = 'block';
                shortBlock.style.display = 'none';
                button.textContent = 'Lees minder...';

            }

        });

    });

});

document.addEventListener('DOMContentLoaded', function () {

    const wrappers = document.querySelectorAll('.coll_bottom_content');

    wrappers.forEach(function(wrapper) {

        const headings = wrapper.querySelectorAll('h3');

        headings.forEach(function(h3) {

            const content = h3.nextElementSibling;

            if (!content) {
                return;
            }

            const item = document.createElement('div');
            item.classList.add('accordion-item');

            const button = document.createElement('button');
            button.classList.add('accordion-header');
            button.type = 'button';

            button.innerHTML = `
                <h3>${h3.innerHTML}</h3>
                <span class="accordion-icon"></span>
            `;

            const body = document.createElement('div');
            body.classList.add('accordion-body');
            body.style.display = 'none';

            body.innerHTML = content.outerHTML;

            item.appendChild(button);
            item.appendChild(body);

            h3.replaceWith(item);
            content.remove();

            button.addEventListener('click', function() {

                const isOpen = body.style.display === 'block';

                body.style.display = isOpen ? 'none' : 'block';

                button.classList.toggle('active');

            });

        });

    });

});